module.exports = __webpack_public_path__ + "static/media/P22.dfc0baf7.png";